export const environment = {
  production: false,
  url: 'https://api.sandbox-taqe.com/v2',
  assets_path: 'https://mfe-modulo-test.sandbox-taqe.com/',
  local: false,
  url_web_v2: 'https://gerenciador.sandbox-taqe.com',
};
